import * as Partners from './partners';
import * as Credentials from './credentials';
import * as Providers from './providers';
import { Industries } from './industries';
import { UploadStatus } from './uploadStatus';
import { ContactCenter } from './contactCenter';
import Countries from './countries';
export var Constants = {
    Partners: Partners,
    Industries: Industries,
    UploadStatus: UploadStatus,
    Credentials: Credentials,
    Providers: Providers,
    ContactCenter: ContactCenter,
    Countries: Countries
};
